import React from 'react';
import PropTypes from 'prop-types';
import withSelfServeCreator from 'withSelfServeCreator';
import SelfServePopup from './SelfServePopup';

const RECIPIENT_LABEL = "Recipient's answer will appear here. ";
const LINE_HEIGHT = 18;
const MINIMUM_WIDTH = 165;
const MINIMUM_HEIGHT = 30;
const POPUP_PADDING = 6;

export class TextBoxPopup extends React.PureComponent {
  render() {
    const numOfLines = this.props.height / LINE_HEIGHT;
    const recipientLabel = [];
    for (let i = 0; i < numOfLines; i += 1) {
      recipientLabel.push(
        <div
          key={`recipient-label-${i}`}
          className="popup-recipient-label-container"
        >
          {RECIPIENT_LABEL.repeat(this.props.width / MINIMUM_WIDTH)}
        </div>,
      );
    }
    return (
      <SelfServePopup
        isActive={this.props.isActive}
        width={this.props.width}
        height={this.props.height}
        userData={this.props.userData}
        zoomFactor={this.props.zoomFactor}
        isPreviewMode={this.props.isPreviewMode}
      >
        <div
          className="request-signature-widget text-box-popup"
          style={{
            width: this.props.width,
            height: this.props.height,
          }}
        >
          <div
            style={{
              padding: POPUP_PADDING,
            }}
          >
            <div
              style={{
                height: this.props.height - (POPUP_PADDING * 2),
                overflow: 'hidden',
              }}
            >
              {recipientLabel}
            </div>
          </div>
        </div>
      </SelfServePopup>
    );
  }
}

TextBoxPopup.defaultProps = {
  isActive: false,
  isPreviewMode: false,
  userData: '',
  zoomFactor: 1,
};

TextBoxPopup.propTypes = {
  height: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  isPreviewMode: PropTypes.bool,
  width: PropTypes.number.isRequired,
  userData: PropTypes.string,
  zoomFactor: PropTypes.number,
};

const TextBoxPopupWithSelfServeCreator = withSelfServeCreator(TextBoxPopup, {
  withDragAndResizeProps: {
    resizeProps: {
      minWidth: MINIMUM_WIDTH,
      minHeight: MINIMUM_HEIGHT,
    },
  },
});

export default TextBoxPopupWithSelfServeCreator;



// WEBPACK FOOTER //
// ./src-react/Popups/SelfServeBuilderPopups/TextBoxPopup.jsx